import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  getCurrentFY,
  getDaysInFYMonths,
  months,
  secondsToHHMM,
  sumArrayOfObjects,
  timeToSeconds,
} from "../../../../Utilitie";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import HalfDoughnutChart from "../../../../CHARTS/HalfDoughnutChart";
const TerminalDetentionNkj = ({ selectedFy, selectedFilters }) => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const selectedMonth = [...selectedFilters.selectedMonth];
  const selectedYears = [...selectedFilters.selectedYear];
  const [data, setData] = useState(null);

  const fd = [];
  const fd3 = [];
  if (data) {
    for (let i = 0; i < selectedYears.length; i++) {
      const y = selectedYears[i];
      fd3.push(...data.filter((o) => o.YEAR === y));
    }

    for (let i = 0; i < selectedMonth.length; i++) {
      const m = selectedMonth[i]?.slice(0, 3).toLowerCase();
      fd.push(...fd3.filter((o) => o.MONTH?.toLowerCase() === m));
    }
  }

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(
          `${urlPrefix}nkjterminaldetention?FyYear=${selectedFy}`,
        );
        if (response.status === "ok" && Array.isArray(response.data)) {
          setData(response.data);
        }
      } catch (err) {
        console.error(err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedFy]);

  const [chartData, setChartData] = useState(null);
  const [chartData2, setChartData2] = useState(null);
  const [chartData3, setChartData3] = useState(null);
  const [chartData4, setChartData4] = useState(null);
  const product = ["Total Rakes"];
  const product4 = ["Total Detention"];
  const product3 = [
    "arr_to_block",
    "block_to_release",
    "release_to_shunting_start",
    "shunting_time",
    "shunting_complition_to_load_ready",
    "load_ready_to_pressure_advice",
    "pressure_time",
    "pressure_resdy_to_despatch",
  ];
  let years = [...new Set(data && data.map((o) => o.YEAR))];
  years.sort((a, b) => a.replace("-", "") - b.replace("-", ""));

  useEffect(() => {
    const chart1 = {
      dimensions: ["product", ...years],
      series: product.map((p) => {
        const obj = { product: p };

        years.forEach((year) => {
          const total = fd
            .filter((d) => d.YEAR === year)
            .reduce((sum, item) => sum + item.total_rakes, 0);

          obj[year] = total.toFixed(1);
        });

        return obj;
      }),
    };

    const chart4 = {
      dimensions: ["product", ...years],
      series: product4.map((p) => {
        const obj = { product: p };

        years.forEach((year) => {
          const total = fd
            .filter((d) => d.YEAR === year)
            .reduce((sum, item) => sum + item.total_detention, 0);

          obj[year] = total.toFixed(1);
        });

        return obj;
      }),
    };

    const chart3 = {
      dimensions: ["type", ...years],
      series: product3.map((field) => {
        const obj = { type: field };

        years.forEach((year) => {
          const total = fd
            .filter((d) => d.YEAR === year)
            .reduce((sum, item) => sum + (Number(item[field]) || 0), 0);

          obj[year] = total;
        });

        return obj;
      }),
    };

    setChartData(chart1);
    setChartData4(chart4);
    setChartData3(chart3);
  }, [fd.length]);

  useEffect(() => {
    if (fd && selectedFy) {
      let dataToSum = fd && fd.filter((d) => d.YEAR === selectedFy);

      let sum = sumArrayOfObjects(dataToSum, [], [], "");
      const names = [
        "arr_to_block",
        "block_to_release",
        "release_to_shunting_start",
        "shunting_time",
        "shunting_complition_to_load_ready",
        "load_ready_to_pressure_advice",
        "pressure_time",
        "pressure_resdy_to_despatch",
      ];
      const tempChartData = [];

      names.forEach((name) => {
        tempChartData.push({
          name: name.replace("SM_", "").replace("or Po", "or\nPo"),
          value: sum?.[0]?.[name] ?? 0,
        });
      });
      setChartData2(tempChartData);
    }
  }, [fd.length, selectedFy]);

  return (
    <div>
      <div className="row">
        <h5 className="text-start"> Terminal Detention</h5>
        <hr />
        <div className="col-md-12 border-end mb-4">
          <h5>
            Terminal Detention
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(in No)</b>
          </h5>
          {chartData3 && (
            <GroupedBarChart
              data={chartData3}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
              height={300}
              decimal={2}
            />
          )}{" "}
        </div>
        <hr />

        <div className="col-md-3 border-end">
          <h5>
            Total Rakes
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(in No)</b>
          </h5>
          {chartData && (
            <GroupedBarChart
              data={chartData}
              rotateText={0}
              from={`Block_C`}
              chartType="bar"
              height={300}
              decimal={2}
            />
          )}{" "}
        </div>
        <div className="col-md-3 border-end">
          <h5>
            Total Detention
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(in No)</b>
          </h5>
          {chartData4 && (
            <GroupedBarChart
              data={chartData4}
              rotateText={0}
              from={`Block_T`}
              chartType="bar"
              height={300}
              decimal={2}
            />
          )}{" "}
        </div>
        <div className="col-md-6 ">
          <div className="row">
            <div className="d-flex justify-content-between">
              <h5>
                Terminal Detention
                <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>
                  (for {selectedFy})
                </b>
              </h5>
            </div>
          </div>
          {chartData2 && (
            <HalfDoughnutChart
              // title="Sales Distribution"
              data={chartData2}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default TerminalDetentionNkj;
